/** @format */

import {KpiType, MediaplanType} from '../types';

const getPrimaryKpi = (mediaplan: MediaplanType): KpiType | undefined => {
  return mediaplan.kpis?.find(kpi => kpi.primary);
};

export {getPrimaryKpi};
